import Immutable from 'seamless-immutable'

import { createReducer } from 'reduxsauce'
import { FormsTypes, SocketTypes } from '../actions'

export const INITIAL_STATE = Immutable({
  currentQuestion: null,
  dragging: false,
  hasValidationError: false,
  inputValue: '',
  isLastQuestion: false,
  showToolTip: false,
  type: '',
})

const newQuestion = (state, { result }) => {
  return state.merge({
    currentQuestion: result.question,
    isLastQuestion: result.last,
    type: result.type,
  })
}

const updateInputField = (state, { inputValue }) => state.merge({ inputValue })

const setValidationError = (state) => state.merge({ hasValidationError: true })

const submitAnswer = (state) => state.merge(INITIAL_STATE)

const startDrag = (state) => state.merge({ dragging: true, showToolTip: true })

const stopDrag = (state) => state.merge({ dragging: false, showToolTip: false })

const toolTipOn = (state) => state.merge({ showToolTip: true })

const toolTipOff = (state) => state.merge({ showToolTip: false })

const clearForms = (state) => state.merge(INITIAL_STATE)

const ACTION_HANDLERS = {
  [SocketTypes.NEW_QUESTION]: newQuestion,
  [FormsTypes.UPDATE_INPUT_FIELD]: updateInputField,
  [FormsTypes.SET_VALIDATION_ERROR]: setValidationError,
  [FormsTypes.SUBMIT_ANSWER]: submitAnswer,
  [FormsTypes.START_DRAG]: startDrag,
  [FormsTypes.STOP_DRAG]: stopDrag,
  [FormsTypes.TOOL_TIP_ON]: toolTipOn,
  [FormsTypes.TOOL_TIP_OFF]: toolTipOff,
  [FormsTypes.CLEAR_FORMS]: clearForms,
}

export default createReducer(INITIAL_STATE, ACTION_HANDLERS)
